import { datadogRum } from '@datadog/browser-rum';

export function initInputTracker() {
  document.addEventListener('blur', (e) => {
    const el = e.target;
    if (!['INPUT', 'TEXTAREA'].includes(el.tagName)) return;
    if (['checkbox', 'radio', 'file', 'submit', 'button'].includes(el.type)) return;
    if (!el.value) return;

    // Find label from MUI FormControl or data-test-id
    const testId = el.getAttribute('data-test-id') || el.closest('[data-test-id]')?.dataset.testId;
    const muiLabel = el.closest('.MuiFormControl-root')?.querySelector('label')?.textContent?.trim();
    const fieldName = testId || muiLabel || el.placeholder || el.name || 'input';
    const value = el.type === 'password' ? '***' : el.value;

    datadogRum.addAction(`Entered value in "${fieldName}"`, {
      field: fieldName,
      value,
    });
  }, { capture: true });
}
